/**
 * Sorts the given languages by language code.
 *
 * @param languageTags Known language tags (e.g. en-US).
 * @returns Sorted list of language names which are used for display.
 */
export function sortDisplayLanguages(languageTags: ReadonlyArray<string>): string[] {
  return [...languageTags].sort()
}
